import { motion } from "framer-motion";
import { ShieldCheck } from "lucide-react";
import { LogoMark } from "@/components/Logo";

export const Waitlist = () => (
  <section id="waitlist" className="px-3 pb-6 pt-20 sm:px-6 sm:pt-24" data-testid="waitlist-section">
    <div className="grain relative mx-auto max-w-7xl overflow-hidden rounded-[2.5rem] bg-[#1C2B4A] px-5 py-16 sm:px-12 sm:py-24">
      <LogoMark bare size={420} className="pointer-events-none absolute -bottom-32 -right-24 opacity-[0.14] sm:-right-10" />
      <div className="relative mx-auto grid max-w-5xl items-center gap-12 lg:grid-cols-2">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        >
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-[#C9D2E3]">The waitlist</p>
          <h2 className="font-display mt-6 text-4xl font-normal leading-[1.08] tracking-tight text-white sm:text-5xl lg:text-6xl">
            We're making a few <span className="italic">updates.</span>
          </h2>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-[#E3E8F1]">
            The waitlist is temporarily paused while we get things ready. Check back soon!
          </p>
        </motion.div>
        <div className="rounded-3xl bg-[#FAF7F2] p-6 text-[#16203A] sm:p-8" role="status">
          <p className="font-display text-2xl sm:text-3xl">We'll be back soon.</p>
          <p className="mt-3 text-base leading-relaxed text-[#464E62]">
            Thanks for your interest in Otti. We're taking a short pause on new signups.
          </p>
        </div>
      </div>
    </div>
  </section>
);
